import request from "@/utils/request";

export function getMainBanner() {
  return request({
    url: "/api/main_banner/",
    method: "get",
  });
}

export function postMainBanner(_, data) {
  return request({
    url: "/api/admin/main_banner/",
    method: "post",
    data,
  });
}
